import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { api, useGetLojaAtualQuery } from '../../api'
import type { AppDispatch } from '../../store'
import { imprimeNoAparelho, type OpcoesImpressaoTotem } from '../../lib/impressao-totem'
import {
  acompanharImpressaoDoPedido,
  aoMudarFalhaDeImpressao,
  documentosDoPedido,
  falhouImpressaoDoPedido,
} from '../../lib/impressao-pedido-totem'

export function useImpressaoNoAparelho({
  idPedido,
  ehTotem,
  opcoes,
}: {
  idPedido: string | undefined
  ehTotem: boolean
  opcoes: OpcoesImpressaoTotem
}): boolean {
  const dispatch = useDispatch<AppDispatch>()
  const { data: loja } = useGetLojaAtualQuery()
  const servidor = loja?.impressaoLocal?.servidor ?? null
  const [falhou, setFalhou] = useState(false)

  useEffect(() => {
    if (!ehTotem || !idPedido || !documentosDoPedido(opcoes).length || !imprimeNoAparelho()) return

    const atualizar = (): void => setFalhou(falhouImpressaoDoPedido(idPedido))
    const desligar = aoMudarFalhaDeImpressao(atualizar)
    atualizar()

    void acompanharImpressaoDoPedido(idPedido, opcoes, {
      servidor,
      buscar: (pedido, documento) =>
        dispatch(
          api.endpoints.getDocumentoImpressaoTotem.initiate(
            { idPedido: pedido, documento },
            { subscribe: false, forceRefetch: true },
          ),
        ).unwrap(),
    })

    return desligar
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ehTotem, idPedido, opcoes.imprimirSenha, opcoes.imprimirResumo, opcoes.nota, servidor, dispatch])

  return falhou
}
